const getters = {
  apiStatus: state => state.app.apiStatus,
  lang: state => state.app.lang,
  userInfo: state => state.app.userInfo,
  isApp: state => state.app.isApp,
  OS: state => state.app.OS,
  isAbroad: state => state.app.isAbroad
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js